<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">MCDONNELL DOUGLAS F-4 PHANTOM</h1>
<p class="author">Geoff Coughlin</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?589a222f